import React from 'react';
import MatchStatus from '../MatchStatus/MatchStatus';
import Picture from '../../../shared/components/Picture';

function MatchTopRow({ sponsorImageUrl, matchStatus, minutes, extraMinutes, dateLabel, matchTime, isTimeTbd, leagueMatchTitle }) {
  return (
    <div className="mls-c-priority-match__top-row">
      <div className="mls-c-priority-match__broadcast-info">
        {sponsorImageUrl ? <Picture src={sponsorImageUrl} title="Sponsor" /> : <div className='mls-c-priority-match__league-title'>{leagueMatchTitle}</div>}
      </div>
      <MatchStatus
        matchStatus={matchStatus}
        minutes={minutes}
        extraMinutes={extraMinutes}
        dateLabel={dateLabel}
        matchTime={matchTime}
        isTimeTbd={isTimeTbd}
      />
    </div>
  );
}

export default MatchTopRow;
